import ScrollReveal from 'scrollreveal';
import {TweenMax, Power2, TimelineLite, TimelineMax} from "gsap/TweenMax";
import "./mobile-detect";

window.$ = require('jquery');

window.sr = ScrollReveal();


$(document).ready(function(){
  ScrollReveal().reveal('.header-main', {
    opacity: null,
    beforeReveal: function (el) {
      $(el).addClass("activeAnim");
    }
});

function myCallback (el) {
  var tl = new TimelineMax();
  tl.to(".line-anim", 0.7, {autoAlpha:1, scaleX:1, ease: Power4.easeOut })
  .to(".line-anim", 0.7, {autoAlpha:1, scaleY:1, ease: Power4.easeOut })
  .staggerFromTo(".sf", 0.5, {autoAlpha:0, y:50}, {autoAlpha:1, y:0, ease: Sine.easeOut }, 0.2);
}

ScrollReveal().reveal('.hero-content-row', {opacity: null, beforeReveal: myCallback });


ScrollReveal().reveal('.animFade', {
    easing: "linear",
    opacity: 0,
    duration: 1000
});

ScrollReveal().reveal('.fadeDelay', {
  delay: 0,
  interval: 200
})



   $("[data-scrollto]").on("click", function(e){
       e.preventDefault();
       var scrollToElm = $(this).data("scrollto");
       var scrollPos = $("#"+scrollToElm).offset().top - $(".header-main").height();
      $("html,body").stop().animate({scrollTop: scrollPos}, 1000);
      $(".hamburger.h-active").trigger("click");
   });


$(document).on("keyup", function(e){
   console.log();
   if(e.keyCode === 27){
     $(".fancybox-close-small").trigger("click");
   }
});

var activeHeader = function() {
    var winPos = $(window).scrollTop();
    if (winPos > 40) {
      $(".header-main").addClass("header-active");
    } else {
      $(".header-main").removeClass("header-active");
    }
  };
  activeHeader();
  $(window).scroll(function() {
    activeHeader();
  });


  $(".hamburger").click(function(event) {
    $(this).toggleClass("h-active");
    $("body").toggleClass("menu-active");
  });




}); //document ready end

